import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { EventService, ErrorService } from '..';
import { HandleOperationInfo, UpdateOperationInfoRequest, HandleOperationInfoPageResponse } from '../models/handlemonitoring';
import { ConfigService } from './config.service';
import { ModuleInfoPageResponse, ModuleInfo, UpdateModuleInfoRequest } from '../models';
import { ReceiverPageResponse } from '../models';




@Injectable({providedIn: 'root'})
export class CheatDetectionService {
    private baseURL = ConfigService.getApiEndpoint() +'v1/';

    constructor(
        private http: HttpClient,
        private eventService: EventService,
        private error: ErrorService
    ) { }

    search(query: any, type: string): Observable<HandleOperationInfoPageResponse> {
        let params = query;
        params.type = type;
        return this.http.get<HandleOperationInfoPageResponse>(this.baseURL + 'handleoperationinfo/', { params: params }).pipe(
                catchError(this.error.handleError('searchHandleOperationInfo', null))
        );
    }

    getOne(id: number): Observable<HandleOperationInfo> {
        return this.http.get<HandleOperationInfo>(this.baseURL + 'handleoperationinfo/' + id).pipe(
            catchError(this.error.handleError('getHandleOperationInfo', null))
        );
    }

    update(id: number, request: UpdateOperationInfoRequest): Observable<HandleOperationInfo> {
        return this.http.put<HandleOperationInfo>(this.baseURL + 'handleoperationinfo/' + id, request).pipe(
            tap(_ => this.eventService.addAlert(`updated HandleOperationInfo: ${id}`)),
            catchError(this.error.handleError('updateHandleOperationInfo', null))
        );
    }

    searchModuleInfo(query: any, type: number): Observable<ModuleInfoPageResponse> {
        let params = query;
        params.type = type;
        return this.http.get<ModuleInfoPageResponse>(this.baseURL + 'moduleinfo/', { params: params }).pipe(
                catchError(this.error.handleError('searchModuleInfo', null))
        );
    }

    updateModuleInfo(id: number, request: UpdateModuleInfoRequest): Observable<ModuleInfo> {
        return this.http.put<ModuleInfo>(this.baseURL + 'moduleinfo/' + id, request).pipe(
            tap(_ => this.eventService.addAlert(`updated ModuleInfo: ${id}`)),
            catchError(this.error.handleError('updateModuleInfo', null)));
    }

    searchReceiver(query: any): Observable<ReceiverPageResponse> {
        let params = query;
        return this.http.get<ReceiverPageResponse>(this.baseURL + 'receiver/', { params: params }).pipe(
                catchError(this.error.handleError('searchReceiver', null))

        );
    }

}
